import Mock from 'mockjs';

const MockData = Mock.mock({
  'status': {
    'success': true,
    'httpstatuscode': 200
  },
  'statistics': {
    'pagetitle': 'Berry - React Material Admin Dashboard Template',
    'pageurl': 'https://berrydashboard.io/free/dashboard/default',
    'time': 3.22,
    'creditsremaining': 94,
    'allitemcount': 181,
    'totalelements': 937,
    'waveurl': 'http://wave.webaim.org/report?url=https://berrydashboard.io/free/dashboard/default'
  },
  'categories': {
    'error': {
      'description': 'Errors',
      'count': 10,
      'items': {
        'alt_missing': {
          'id': 'alt_missing',
          'description': 'Missing alternative text',
          'count': 1
        },
        'label_missing': {
          'id': 'label_missing',
          'description': 'Missing form label',
          'count': 1
        },
        'button_empty': {
          'id': 'button_empty',
          'description': 'Empty button',
          'count': 5
        },
        'link_empty': {
          'id': 'link_empty',
          'description': 'Empty link',
          'count': 2
        },
        'aria_reference_broken': {
          'id': 'aria_reference_broken',
          'description': 'Broken ARIA reference',
          'count': 1
        }
      }
    },
    'contrast': {
      'description': 'Contrast Errors',
      'count': 13,
      'items': {
        'contrast': {
          'id': 'contrast',
          'description': 'Very low contrast',
          'count': 13
        }
      }
    },
    'alert': {
      'description': 'Alerts',
      'count': 13,
      'items': {
        'h1_missing': {
          'id': 'h1_missing',
          'description': 'Missing first level heading',
          'count': 1
        },
        'heading_skipped': {
          'id': 'heading_skipped',
          'description': 'Skipped heading level',
          'count': 4
        },
        'heading_possible': {
          'id': 'heading_possible',
          'description': 'Possible heading',
          'count': 2
        },
        'link_redundant': {
          'id': 'link_redundant',
          'description': 'Redundant link',
          'count': 2
        },
        'noscript': {
          'id': 'noscript',
          'description': 'Noscript element',
          'count': 1
        },
        'title_redundant': {
          'id': 'title_redundant',
          'description': 'Redundant title text',
          'count': 3
        }
      }
    },
    'feature': {
      'description': 'Features',
      'count': 4,
      'items': {
        'alt': {
          'id': 'alt',
          'description': 'Alternative text',
          'count': 1
        },
        'fieldset': {
          'id': 'fieldset',
          'description': 'Fieldset',
          'count': 2
        },
        'lang': {
          'id': 'lang',
          'description': 'Language',
          'count': 1
        }
      }
    }
  }
});

export default MockData;

